export function transformSmartProperties(properties) {
  return properties.map(property => ({
    propertyName: property.propertyName,
    label: property.propertyLabel,
    objectType: property.objectTypeId,
    promptQuestion: property.config.promptQuestion
  }));
}